export default __webpack_public_path__ + "static/media/MA (Development Studies).d98f071e.pdf";